"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _colors = require("HubStyleTokens/colors");

var _ToolbarDropdownButton = _interopRequireDefault(require("../toolbar/ToolbarDropdownButton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyleProtectedMenuButton = _interopRequireDefault(require("../style-protected/StyleProtectedMenuButton"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  vertical-align: middle;\n  margin-bottom: 2px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "LineHeightMenu__StyledIcon",
  componentId: "fexyvh-0"
})(_templateObject());

var LineHeightMenu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LineHeightMenu, _Component);

  function LineHeightMenu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LineHeightMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LineHeightMenu).call(this, props));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LineHeightMenu, [{
    key: "handleClick",
    value: function handleClick(_ref) {
      var value = _ref.currentTarget.value;
      this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          lineHeight = _this$props.lineHeight,
          tooltip = _this$props.tooltip,
          dropdownClassName = _this$props.dropdownClassName;
      return _react.default.createElement(_ToolbarDropdownButton.default, {
        dropdownClassName: dropdownClassName,
        tooltip: tooltip,
        buttonIconName: "lineHeight",
        menuWidth: 100
      }, _react.default.createElement(_UIList.default, null, options.map(function (_ref2) {
        var raw = _ref2.text.raw,
            value = _ref2.value;
        return _react.default.createElement(_StyleProtectedMenuButton.default, {
          size: "xs",
          key: value,
          onClick: _this2.handleClick,
          value: value
        }, raw, lineHeight === value && _react.default.createElement(StyledIcon, {
          size: 14,
          name: "success",
          color: _colors.EERIE
        }));
      })));
    }
  }]);
  return LineHeightMenu;
}(_react.Component);

exports.default = LineHeightMenu;
LineHeightMenu.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  options: _react.PropTypes.array.isRequired,
  tooltip: _react.PropTypes.string.isRequired,
  dropdownClassName: _react.PropTypes.string,
  lineHeight: _react.PropTypes.number
};
module.exports = exports.default;